import { DynamicConfig } from '@statsig/js-client';
import { StatsigService } from '@services/statsig.service';

import { Injectable } from '@angular/core';

export enum MESSAGING_DATADOG_LOGS_CONFIGS {
  isMessageReceivedLoggingEnabled = 'isMessageReceivedLoggingEnabled',
  isMessagingSendbirdConnectionRetryEnabled = 'isMessagingSendbirdConnectionRetryEnabled',
}

export enum MESSAGING_WEB_PCC_REDUCTION_CONFIGS {
  isWebPCCReductionEnabledBelowDesktop = 'isWebPCCReductionEnabledBelowDesktop',
  isSharedWorkerEnableForMessaging = 'isSharedWorkerEnableForMessaging',
}

export enum MESSAGING_FEATURE_CONFIGS {
  isMessagingTeamsRenameEnabled = 'isMessagingTeamsRenameEnabled',
}

// dynamic config from statsig
export const DATADOG_LOGS_CONFIG_NAME = 'fe-messaging-datadog-logs';
export const WEB_PCC_REDUCTION_CONFIG_NAME = 'fe-messaging-pcc-reduction';
export const MESSAGING_TEAMS_RENAME_CONFIG_NAME = 'fe-messaging-rename-team';
export const MESSAGING_SESSION_AUTH_ENABLED = 'messaging_session_auth_enabled';

@Injectable({ providedIn: 'root' })
export class MessagingFeatureFlagService {
  private dataDogLogsConfig: DynamicConfig;
  private webPCCReductionConfig: DynamicConfig;
  private messagingTeamsRenameConfig: DynamicConfig;

  constructor(
    private statsigService: StatsigService,
  ) {
    this.dataDogLogsConfig = this.statsigService.evaluateDynamicConfig(DATADOG_LOGS_CONFIG_NAME);
    this.webPCCReductionConfig = this.statsigService.evaluateDynamicConfig(WEB_PCC_REDUCTION_CONFIG_NAME);
    this.messagingTeamsRenameConfig = this.statsigService.evaluateDynamicConfig(MESSAGING_TEAMS_RENAME_CONFIG_NAME);
  }

  // methods to get the specific properties with from config.value object
  public isMessageReceivedLoggingEnabled(): boolean {
    return this.dataDogLogsConfig.get(MESSAGING_DATADOG_LOGS_CONFIGS.isMessageReceivedLoggingEnabled, false);
  }

  public isMessagingSendbirdConnectionRetryEnabled(): boolean {
    return this.dataDogLogsConfig.get(MESSAGING_DATADOG_LOGS_CONFIGS.isMessagingSendbirdConnectionRetryEnabled, false);
  }

  public isSharedWorkerEnableForMessaging(): boolean {
    return this.webPCCReductionConfig.get(MESSAGING_WEB_PCC_REDUCTION_CONFIGS.isSharedWorkerEnableForMessaging, false);
  }

  public isMessagingTeamsRenameEnabled(): boolean {
    return this.messagingTeamsRenameConfig.get(MESSAGING_FEATURE_CONFIGS.isMessagingTeamsRenameEnabled, false);
  }

  public isMessagingSessionAuthEnabled(): boolean {
    return this.statsigService.evaluateGate(MESSAGING_SESSION_AUTH_ENABLED);
  }
}
